import { extend, notificationType } from 'flarum/extend';
import app from 'flarum/app';

import ShowLastPost from './ShowLastPost';

app.initializers.add('flarumalshain-showlastpost', () => {
  ShowLastPost();
});